import React from 'react';

const TAG_OPTIONS = [
  { value: '', label: '—', className: '' },
  { value: 'active', label: 'Active', className: 'tag-active' },
  { value: 'temporary', label: 'Temporary', className: 'tag-temporary' },
  { value: 'deprecate', label: 'Deprecate', className: 'tag-deprecate' },
  { value: 'shutdown', label: 'Shutdown', className: 'tag-shutdown' },
];

const TAG_PRIORITY = { active: 1, temporary: 2, deprecate: 3, shutdown: 4 };
const TAG_LABELS = { active: 'Active', temporary: 'Temporary', deprecate: 'Deprecate', shutdown: 'Shutdown' };

export function getTagPriority(tag) {
  return TAG_PRIORITY[tag] || 5;
}

export function getTagLabel(tag) {
  return TAG_LABELS[tag] || '';
}

export function groupAndSort(items, tagMap, nameKey, currentSortFn, tagFilter) {
  const groups = { active: [], temporary: [], deprecate: [], shutdown: [], untagged: [] };

  for (const item of items) {
    const tag = tagMap[item[nameKey]] || '';
    const bucket = tag && groups[tag] ? tag : 'untagged';

    if (tagFilter && tagFilter !== 'all') {
      if (tagFilter === 'untagged' && bucket !== 'untagged') continue;
      if (tagFilter !== 'untagged' && bucket !== tagFilter) continue;
    }

    groups[bucket].push(item);
  }

  if (currentSortFn) {
    for (const key of Object.keys(groups)) {
      groups[key] = currentSortFn(groups[key]);
    }
  }

  const result = [];
  for (const [group, list] of Object.entries(groups)) {
    if (list.length === 0) continue;
    result.push({ _groupHeader: true, group, label: group === 'untagged' ? 'Untagged' : TAG_LABELS[group], count: list.length });
    result.push(...list);
  }
  return result;
}

const FILTER_OPTIONS = [
  { value: 'all', label: 'All Tags' },
  { value: 'active', label: 'Active' },
  { value: 'temporary', label: 'Temporary' },
  { value: 'deprecate', label: 'Deprecate' },
  { value: 'shutdown', label: 'Shutdown' },
  { value: 'untagged', label: 'Untagged' },
];

export function TagFilter({ value, onChange }) {
  return (
    <select
      className="tag-filter-select"
      value={value || 'all'}
      onChange={e => onChange(e.target.value)}
    >
      {FILTER_OPTIONS.map(opt => (
        <option key={opt.value} value={opt.value}>{opt.label}</option>
      ))}
    </select>
  );
}

const STICKY_BASE = { position: 'sticky', zIndex: 2 };
const STICKY_HEAD = { position: 'sticky', zIndex: 3 };

export const stickyTh = [
  { ...STICKY_HEAD, left: 0, width: 32, minWidth: 32, background: 'var(--bg-secondary)' },
  { ...STICKY_HEAD, left: 32, width: 90, minWidth: 90, background: 'var(--bg-secondary)' },
  { ...STICKY_HEAD, left: 122, minWidth: 180, background: 'var(--bg-secondary)' },
];
export const stickyTd = [
  { ...STICKY_BASE, left: 0, width: 32, minWidth: 32, background: 'var(--bg-card)' },
  { ...STICKY_BASE, left: 32, width: 90, minWidth: 90, background: 'var(--bg-card)' },
  { ...STICKY_BASE, left: 122, minWidth: 180, background: 'var(--bg-card)' },
];
export const stickyGroupTd = [
  { ...STICKY_BASE, left: 0, width: 32, minWidth: 32, background: 'var(--bg-secondary)' },
  { ...STICKY_BASE, left: 32, width: 90, minWidth: 90, background: 'var(--bg-secondary)' },
  { ...STICKY_BASE, left: 122, minWidth: 180, background: 'var(--bg-secondary)' },
];

export default function ServiceTagDropdown({ value, onChange }) {
  const current = TAG_OPTIONS.find(o => o.value === (value || '')) || TAG_OPTIONS[0];

  return (
    <select
      className={`tag-dropdown ${current.className}`}
      value={value || ''}
      onChange={e => onChange(e.target.value || null)}
      onClick={e => e.stopPropagation()}
    >
      {TAG_OPTIONS.map(opt => (
        <option key={opt.value} value={opt.value}>{opt.label}</option>
      ))}
    </select>
  );
}
